<template>
  <b-card>
    <div slot="header">
      <i class="fa fa-user-o"></i> Minha Conta
    </div>
    <b-form>
      <b-form-group label="Email" label-for="basicStatic" :label-cols="3" :horizontal="true">
        <b-input-group v-if="!editingEmail" >
          <b-form-input plaintext id="basicStatic" type="email" v-model="email"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="editingEmail = true">
              <i class="fa fa-edit"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-input-group v-if="editingEmail" >
          <b-form-input id="basicName" type="email" v-model="email"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="updateMe">
              <i class="fa fa-check"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-form>
    <b-form>
      <b-form-group label="Whatsapp" label-for="basicStatic" :label-cols="3" :horizontal="true">
        <b-input-group v-if="!editingWhatsapp" >
          <b-form-input plaintext id="basicStatic" type="text" v-model="whatsapp"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="editingWhatsapp = true">
              <i class="fa fa-edit"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-input-group v-if="editingWhatsapp" >
          <b-form-input id="basicName" type="text" v-model="whatsapp"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="updateMe()">
              <i class="fa fa-check"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-form>
    <b-form>
      <b-form-group label="Senha" label-for="basicStatic" :label-cols="3" :horizontal="true">
        <b-input-group v-if="!editingPassword" >
          <b-form-input plaintext id="basicStatic" type="text" value="*******"></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="editingPassword = true">
              <i class="fa fa-edit"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <div v-if="editingPassword">
          <b-input-group>
            <b-form-input id="basicName" type="password" v-model="oldPassword" placeholder="Senha atual"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-form-input id="basicName" type="password" v-model="newPassword" placeholder="Nova senha"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-form-input id="basicName" type="password" v-model="passwordConfirmation" placeholder="Confirme a nova senha"></b-form-input>
          </b-input-group>
          <div class="pull-right" style="margin-top: 10px;">
            <b-button variant="primary" @click="updateMe()">
              <i class="fa fa-check"></i> Alterar Senha
            </b-button>
          </div>
          <div class="pull-right" style="margin-top: 10px; margin-right: 10px;">
            <b-button variant="warning" @click="editingPassword = false">
              <i class="fa fa-ban"></i> Cancelar
            </b-button>
          </div>
        </div>
      </b-form-group>
    </b-form>
    <b-row class="text-right">
      <b-col>
        <b-button variant="primary" @click="goToDesignHistory()">
          <i class="fa fa-history"></i> Acessar Histórico de Sleekers
        </b-button>
      </b-col>
    </b-row>
    <div>
      <b-alert variant="danger" :show="errorMessage">{{errorMessage}}</b-alert>
    </div>
    <div>
      <b-alert variant="success" :show="success">Conta atualizada</b-alert>
    </div>
  </b-card>
</template>
 
<script>
import config from "../config";
import service from "../service";

export default {
  name: "AccountData",
  data() {
    return {
      editingEmail: false,
      editingWhatsapp: false,
      editingPassword: false,
      email: "",
      whatsapp: "",
      newPassword: "",
      oldPassword: "",
      passwordConfirmation: "",
      errorMessage: undefined,
      success: false
    };
  },
  methods: {
    getMe: function() {
      service.getMe().then(user => {
        this.user = user;
        this.email = user.email;
        this.whatsapp = user.whatsapp;
      })
    },
    updateMe: function() {
      this.errorMessage = undefined;
      this.success = false;
      let shouldUpdate = true;
      if (!this.email || this.email.indexOf("@") < 0 || this.email.indexOf(".") < 0) {
        this.errorMessage = "Cheque seu email e tente novamente";
        shouldUpdate = false;
      } else if (this.oldPassword || this.newPassword || this.passwordConfirmation) {
        if (!this.oldPassword) {
          this.errorMessage = "Informe sua senha atual";
          shouldUpdate = false;
        } else if (!this.newPassword) {
          this.errorMessage = "Informe a nova senha";
          shouldUpdate = false;
        } else if (!this.passwordConfirmation || this.passwordConfirmation !== this.newPassword) {
          this.errorMessage = "A confirmação de senha está diferente da nova senha";
          shouldUpdate = false;
        }
      }
      if (shouldUpdate) {
        service.updateMe({email: this.email, whatsapp: this.whatsapp, oldPassword: this.oldPassword, password: this.newPassword}).then(user => {
          this.editingEmail = false;
          this.editingWhatsapp = false;
          this.editingPassword = false;
          this.success = true;
          setTimeout(() => { this.success = false }, 4000);
        }).catch(error => {
          if (error && error.message) {
            this.errorMessage = error.message;
          } else {
            this.errorMessage = "Ocorreu um erro inesperado";
          }
        });
      }
    },
    goToDesignHistory: function () {
      this.$router.push('/design/history');
    }
  },
  created() {
    this.getMe();
  }
};
</script> 

